export const removeAttributesHtmlRegex = /<li>|<\/li>|<ul>|<\/ul>/g
